module.exports = "\n#chartdiv {\n    width: 100%;\n    height: 500px;\n  }\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/client/main-dashchart/main-dashchart.component.css
// module id = ./src/app/client/main-dashchart/main-dashchart.component.css
// module chunks = main